var React = require('react');

function ArrowRightLimeInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.9497 6.99996L17.8995 11.9497L12.9497 16.8995","stroke":"#B2D600","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M17 11.9497L6 11.9497","stroke":"#B2D600","strokeLinecap":"round","key":1})]);
}

ArrowRightLimeInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowRightLimeInline;

ArrowRightLimeInline.default = ArrowRightLimeInline;
